<template>
  <div id="main-link">
    <div class="container py-3">
      <!-- <div class="d-flex justify-content-between align-items-center pt-5 pb-2">
        <div class="title-content-package">{{ bestSellers.periode ?? 'Best Seller' }}</div>
        <router-link to="">
          <div class="btn-show-all">Lihat Semua</div>
        </router-link>
      </div> -->
      <div class="row">
        <div class="col d-flex flex-column align-items-center">
          <div class="badge rounded-pill d-flex align-items-center justify-content-center gap-1 gap-md-3 mb-2 mb-md-3">
            <img
              class="badge-icon"
              src="@/assets/icon/medal-star.png"
              onload="this.style.backgroundColor = 'transparent'"
            />
            <span class="badge-title fm-inter">Layanan Unggulan</span>
          </div>
          <h6 class="main-title fw-bold mb-0">Layanan Paling Banyak Dipesan</h6>
        </div>
      </div>
      <div class="row flex-nowrap overflow-auto">
        <Loading v-if="loading" />
        <Empty v-else-if="bestSellers.length === 0" :message="'Saat ini belum ada Best Seller untuk ditampilkan.'"/>
        <div
          v-else
          v-for="bestSeller in bestSellers.detail.slice(0, 4)"
          :key="bestSeller"
          class="col col-md-3 pt-2 pb-2 px-0"
        >
          <div class="best-seller d-flex flex-column align-items-center">
            <a
              href="#"
              target="_blank"
              @click="handleOnClick"
            >
              <img
                class="best-seller-icon"
                :src="bestSeller.icon"
                onload="this.style.backgroundColor = 'transparent'"
              />
            </a>
            <div class="best-seller-title text-center fw-400">
              <p class="mb-0">{{ bestSeller.nama_pemeriksaan }}</p>
            </div>
            <!-- <div class="desc-link">
              Terjual : {{ bestSeller.total_pesan }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import Loading from '@/components/utility/Loading'
import Empty from '@/components/utility/Empty'
import axios from '@/plugins/axios'
import { analytics } from '@/core/firebase-messaging'

export default {
  components: {
    Loading, Empty
  },

  setup () {
    const loading = ref(false)
    const bestSellers = ref([])

    onMounted(async () => {
      try {
        loading.value = true
        const { data } = await axios.get('app/best_seller')

        if (data.success) {
          bestSellers.value = data.data
          return
        }

        console.error('Error dari service get bestSellers = ', data.message)
        // Reset datanya kalau error
        bestSellers.value = []
        throw data
      } catch (error) {
        console.error('Error dari service get bestSellers = ', error)
        bestSellers.value = []
      } finally {
        loading.value = false
      }
    })

    const handleOnClick = () => {
      analytics.logEvent('best_seller_click')
    }

    return {
      loading,
      bestSellers,
      handleOnClick
    }
  }
}
</script>

<style lang="scss" scoped>
#main-link {
  background: #F7FAFC;
  border-radius: 20px;

  .badge {
    width: 220px;
    background: #3566FC;

    @media (max-width: 580px) {
      width: 137px;
    }

    .badge-title {
      font-size: 18px;
      line-height: 22px;
      font-weight: 400;

      @media (max-width: 580px) {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .best-seller {
    .best-seller-icon {
      width: 100%;
      height: auto;
    }

    .best-seller-title {
      font-size: 18px;
      line-height: 28px;

      @media (max-width: 580px) {
        font-size: 11px;
        line-height: 14px;
        color: #4A5568;
      }
    }
  }
}
</style>
